window.videoModalButton = null;
window.videoModal = document.getElementById('video-modal');
window.videoIframe = videoModal ? videoModal.querySelector('iframe') : false;

[].slice.call(document.querySelectorAll('.video-modal-button, .play-button-modal')).forEach(function(videoButton) {
	videoButton.addEventListener('click', function() {
		videoIframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
		videoIframe.setAttribute('allowfullscreen', true);
		videoIframe.src = this.getAttribute('video-src');
		videoModalButton = this;

		Velocity(videoModal, {opacity: [1,0]}, {duration: 300, display: 'block'});

		setTimeout(function() {
			videoModal.querySelector('.close-modal').focus();
			skipLinkToggleDisplay(true);
			setFocus(true, false);
		}, 300);

		var titleElement = this.parentNode.querySelector('h2, .eyebrow');

		if(titleElement)
			videoIframe.setAttribute('title', titleElement.innerHTML);
	});
});